/**
 * 受け取り用のリンクを開いて、ファイルの保存を始める（issue #114）。
 *
 * リンクは「保存する」扱いで返るので（サーバが保存の名前を付けている）、画面はそのまま残ります。
 * 試験では、ここを差し替えて「どのリンクを開いたか」だけを確かめます（試験の中では実際に開けないため）。
 */
export function startDownload(url: string): void {
  window.location.assign(url);
}
